import * as types from './mutation-types'
import { convertIntToBoolean } from '@/helpers'

let defaultObject = () => ({
  data: {}
})

export default {
  [types.SET_VIDEO] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    convertIntToBoolean(payload, ['status'])
    state.video = payload
  },
  [types.SET_VIDEOS] (state, payload) {
    state.videos = []
    if (payload.data.length > 0) {
      for (let video of payload.data) {
        convertIntToBoolean(video, ['status'])
      }
      state.videos = payload.data
    }
    state.pagination = payload.meta.pagination
  }
}
